import React from "react";

const Privacy = () => {
	return (
		<div className="container">
			<div className="row">
				<div className="col s12">
					<h1 className="center">Mentions légales</h1>
					<p>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ipsum
						voluptatibus numquam quidem voluptate assumenda nesciunt aspernatur
						nostrum quae! Temporibus quisquam deserunt ducimus officia quae?
					</p>
					<ol>
						<li>Lorem ipsum dolor sit.</li>
						<li>Lorem ipsum dolor sit amet, consectetur adipisicing.</li>
						<li>Lorem, ipsum.</li>
						<li>
							Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil
							sed molestias laboriosam. Necessitatibus, tenetur recusandae.
						</li>
					</ol>
					<p>
						Lorem ipsum dolor, sit amet consectetur adipisicing elit. Saepe
						molestiae aut itaque ab, doloribus veniam dolorem optio reiciendis
						odio eaque?
					</p>
				</div>
			</div>
			<div className="row">
				<div className="col s12">
					<h2>1. Article</h2>
					<p>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam hic
						ducimus obcaecati, impedit at ipsa cum voluptates dolores nisi
						blanditiis neque est veniam, autem non.
					</p>
					<p>
						Lorem, ipsum dolor sit amet consectetur adipisicing elit. Omnis,
						tempora obcaecati temporibus inventore dolorem iste?
					</p>
				</div>
			</div>
		</div>
	);
};

export default Privacy;
